import axios from "axios"
import { env } from "../constants"

export const create = (token, data) => {
    const uri = `${env.startpoint}reviews`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

export const photo = (token, file) => {
    const uri = `${env.startpoint}reviews/photos`
    const form = new FormData()
    form.append("file", file)
    const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    return axios.post(uri, form, headers).then(response => response).catch(error => error.response)
}

export const update = (token, id, data) => {
    const uri = `${env.startpoint}reviews/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.patch(uri, data, headers).then(response => response).catch(error => error.response)
}

export const remove = (token, id) => {
    const uri = `${env.startpoint}reviews/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}
